<template>
    <div>

        <!-- Table -->

        <trax-ui-card-plain-header-with-actions :title="lang.polaris.training.competency_domain_lists" :actions="card_actions" :bus="bus">
            <trax-training-competency-domains-crud-table :bus="bus" :id="id" 
                :endpoint="endpoint" :edit-url="editUrl">
            </trax-training-competency-domains-crud-table>
        </trax-ui-card-plain-header-with-actions>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus">
            <trax-training-competency-domains-crud-form :bus="bus" :id="id+'-edit'" :toastr-id="id+'-toastr'"
                :endpoint="endpoint">
            </trax-training-competency-domains-crud-form>
        </trax-ui-modal-default>

        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="lang.polaris.training.list_deletion" :bus="bus">
            {{ lang.polaris.training.confirm_delete_competency_list_q }}
        </trax-ui-modal-confirm>
            
        <!-- Search modal -->

        <trax-ui-modal-default :id="id+'-search'" :bus="bus" :title="lang.polaris.form.advanced_search">
            <trax-training-competency-domains-crud-search :id="id" :bus="bus"></trax-training-competency-domains-crud-search>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>
    
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'trax-training-competency-domains'},
        },
    
        data: function() {
            return {
                lang: lang,
                app_url: app_url,
                endpoint: app_url+"polaris/api/front/competency-domain-lists",
                card_actions: [
                    { icon: 'search', event: this.id+'-search-open' },
                    { icon: 'add_box', event: this.id+'-edit-create' }
                ],
                bus: new Vue()
            }
        },

        computed: {
        
            editUrl() {
                return this.app_url + 'polaris/ui/training/competency-domain/edit';
            }
        }
    }
</script>
